import { ProductThumbnail } from 'lib/hooks/use-products'
import React, { useContext, useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import Detail from 'components/product/Detail'
import { findVariant } from 'pages/products/[collection]/[...product]'
import slugify from 'slugify'
import Close from 'components/svg/Close'
import { State } from 'components/Layout'

type Props = {
	product: ProductThumbnail
	reviews: number
	rating: number
	onClose: () => void
	secondaryButton: JSX.Element
}

export default function QuickView( props: Props ) {
	const { product, reviews, rating, onClose, secondaryButton } = props
	const [ options, setOptions ] = useState({})
	const variant = findVariant( product.variants, options, () => setOptions({}) )
	const { flyout } = useContext( State )

	useEffect( () => {
		if ( flyout === 'cart' ) onClose()
	}, [ flyout ] )

	const variantOptions = Object.fromEntries(
		variant.selectedOptions.map( o => ( [
			o.name,
			slugify( o.value, { lower: true }),
		] ) )
	)

	return (
		<motion.div
			className="quickview"
			initial="initial"
			animate="animate"
			exit="exit"
			variants={{
				initial: { opacity: 0 },
				animate: { opacity: 1, transition: { duration: .2 } },
				exit: {
					opacity: 0,
					pointerEvents: 'none',
					transition: { delay: .1, duration: .3 },
				},
			}}
			onClick={onClose}
		>
			<motion.div onClick={e => e.stopPropagation()}>
				<a className="close" onClick={onClose}>
					<Close />
				</a>
				<Detail
					animate={false}
					product={product}
					variant={variant}
					reviews={reviews}
					rating={rating}
					options={{ ...variantOptions, ...options }}
					setOptions={setOptions}
					secondaryButton={secondaryButton}
				/>
			</motion.div>
			<style jsx global>{`
				.quickview {
					position: fixed;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: rgba( 0, 0, 0, .15 );
					z-index: 1;
					display: grid;
					overflow: auto;
				}
				.quickview .close {
					position: absolute;
					right: 0;
					top: 5vw;
					padding: 20px;
					cursor: pointer;
					z-index: 1;
				}
				.quickview > div {
					position: relative;
					max-width: 980px;
					overflow: auto;
					margin: auto;
					padding: 5vw 0;
				}
				.quickview > div header {
					margin: 0;
					padding: 0;
					grid-template-columns: 1fr 1fr;
					grid-column-gap: 0;
					background: white;
				}
				.quickview > div header > *:not(.buttons):not(picture) {
					margin-left: 60px;
					margin-right: 40px;
				}
				.quickview > div header .rating {
					pointer-events: none;
				}
				.quickview > div .buttons {
					order: 1;
					padding: 20px 16px;
					margin-top: 32px;
					display: grid;
					grid-template-columns: 1fr 1fr;
					grid-gap: 6px;
					border-top: 1px solid #E1E2E4;
				}
				.quickview > div .buttons button {
					margin-top: 0;
					white-space: nowrap;
					padding: 20px;
				}
				.quickview :global(picture + legend) {
					display: none;
				}
			`}</style>
		</motion.div>
	)
}
